/* Core & libraries */
import React, { useState, useEffect } from 'react';
import { useTheme } from "react-jss";
import { FormattedMessage } from "react-intl";
import ContainerFluid from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

/* Helpers, constants, custom methods, internal libraries */
/* Components */
import UCButton from "../../../buttons/index.js";
import { colors } from "../../../../constants/colors.js";
import { useSpinnersContext } from "../../../../contexts/spinnersContext.js";

/* Styles */
import styles from "../styles.js"

const DeleteFooter = props => {
  const { setShowModal, handleSaveModal, disableSubmit, submitText  } = props;

  const theme = useTheme();
  const classes = styles({ theme });

  const spinner = useSpinnersContext();

  return (
    <ContainerFluid className="gx-0">
      <Row>
        <Col className={classes.cancelBtnCol}>
          <UCButton
            onClick={() => setShowModal(false)}
            type="default"
            className={classes.cancelBtn}
            disabled={spinner.deleteCompanyActionSpinner}
            text={<FormattedMessage id="peopleGrid.deleteAction.cancel"/>}
          />
        </Col>
        <Col className={classes.saveBtnCol}>
          <UCButton
            className={`${classes.saveBtn} ${disableSubmit ? classes.customDisabled : ''}`}
            onClick={handleSaveModal}
            type="danger"
            text={submitText ? submitText : <FormattedMessage id="peopleGrid.deleteAction.delete"/>}
            dataTestId="changelanguagesubmit"
            disabled={ disableSubmit }
            loadingStateStyling={ classes.customDisabled }
            spinner={{
              name: spinner.deleteCompanyActionSpinner ? "deleteCompanyActionSpinner" : "deleteActionSpinner",
              size: 20,
              color: colors.white
            }}
          />
        </Col>
      </Row>
    </ContainerFluid>
  )
}

export default DeleteFooter;